import React, { useEffect, useState } from 'react';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { Button, Icon } from '@tencent/spaui';
import CheckboxGroup from '@tencent/spaui-checkboxgroup';
import { report } from 'store/report';
import { showDialog, hideDialog } from 'components/dialog';
import { post } from 'store/request';
import { updateUserAuthStatus } from 'store/user';
import V from './Vector.png';
import V1 from './Vector-1.png';
import './index.scss';
// @ts-ignore
import { activeAccountType } from 'common/const';

const CheckboxData = [
  {
    value: 0,
    children: (
      <div className="protocol">
        已阅读并同意
        <a href="https://connect.qq.com/devuser.html?agreement#/" target="_blank" rel="noreferrer">
          《QQ登录服务协议》
        </a>
      </div>
    ),
  },
  {
    value: 2,
    children: (
      <div className="protocol">
        已阅读并同意
        <a href="https://developers.e.qq.com/developer_platform_advertiser_protocol" target="_blank" rel="noreferrer">
          《腾讯广告开发者平台广告主服务协议》
        </a>
      </div>
    ),
  },
  {
    value: 3,
    children: (
      <div className="protocol">
        已阅读并同意
        <a href="/license01.pdf" target="_blank">
          《腾讯广告营销服务市场用户服务协议》
        </a>
      </div>
    ),
  },
];

const Agreement = () => {
  const [value, setValue] = useState(CheckboxData.map((item) => item.value));
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const handleChange = (e: MouseEvent, val: []) => {
    setValue(val);
  };
  const {
    user: { user },
  } = useTypedSelector((state) => state);
  const handleConfirm = () => {
    if (loading) {
      return;
    }
    setLoading(true);

    post('/app_auto_activation_auth', {
      logins: {
        login_type: user.login_type,
        login_name_type: user.login_name_type,
        login_name: user.qq_number || user.wx_id,
      },
    })
      .then(() => {
        showDialog({
          className: 'auth-success',
          content: (
            <>
              <Icon name="check-filled" />
              <div className="text-bold">已成功开通授权！</div>
              <span className="rect-button light" role="button" onClick={() => hideDialog()}>
                完成
              </span>
            </>
          ),
        });
        report({ event: 'auto_activation_auth_submit' });
        dispatch(updateUserAuthStatus(true));
      })
      .catch(() => {
        // message.error(err);
      })
      .finally(() => setLoading(false));
  };
  return (
    <div className="protocol-dialog">
      <div className="protocol-dialog-title">请阅读以下协议并勾选同意授权，方可授权成功</div>
      <CheckboxGroup vertical data={CheckboxData} value={value} onChange={handleChange} />
      <div className="footer-content">
        <Button className="rect-button light confirm-btn" onClick={hideDialog}>
          取消
        </Button>
        <Button
          loading={loading}
          disabled={value.length !== CheckboxData.length}
          className="rect-button
                    confirm-btn"
          displayType="primary"
          onClick={handleConfirm}
        >
          确定
        </Button>
      </div>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}

const OneKeyAuth: React.FC<Props> = () => {
  const { user } = useTypedSelector((state) => state);
  const [accountList, setAccountList] = useState([]);
  const [readMore, setReadMore] = useState(true);

  useEffect(() => {
    if (Array.isArray(user?.user?.super_admin_accounts)) {
      setAccountList(user?.user?.super_admin_accounts);
    }
  }, [user?.user?.super_admin_accounts]);

  const handleClick = () => {
    report({ event: 'auto_activation_auth_view' });
    showDialog({
      className: 'auth-dialog',
      title: <div>授权协议</div>,
      content: <Agreement />,
    });
  };

  // auto_activation_auth_status 当前登录用户是否做过一键授权
  // 超管 && 没做过一件授权
  // 登陆账号为 广告代理服务商
  // if (true) {
  if (
    user?.roles?.filter((item) => [10, 100].includes(item)).length !== 0 &&
    user?.user?.auto_activation_auth_status === false &&
    user?.user?.active_account_type === activeAccountType.proxyAgency
  ) {
    return (
      <div className="one-key-auth">
        <Button className="btn rect-button" onClick={handleClick} displayType="primary">
          <img
            style={{
              height: '20px',
              width: '15px',
            }}
            src={V}
            alt=""
          />
          <img
            style={{
              width: '9px',
              height: '6px',
              position: 'relative',
              top: '6px',
              left: '-4px',
            }}
            src={V1}
            alt=""
          />
          一键授权
        </Button>
        <div className="one-key-text-desc">
          <div>营销服务市场（员工开通及使用第三方工具能力授权）</div>
          <div>
            1、腾讯广告营销服务市场会持续引入和更新第三方公司研发的工具和服务，旨在辅助服务商在投放等环节提高人效。
          </div>
          <div>
            2、该授权可将工具开通及使用能力授权给贵司员工，包括但不限于管理员、报表分析员、财务人员、运营人员、运营管理员、设计师、子账户管理员等。
          </div>
          <div>3、通过授权后，员工才能使用营销服务市场中提供的工具。</div>
          <div>
            4、员工在使用工具时，只能授权第三方工具通过
            <a href="https://developers.e.qq.com/" target="_blank" rel="noreferrer">
              Marketing API
            </a>
            获取自己管理的账户信息，包括但不限于广告管理、广告洞察、人群管理、数据上报等。
          </div>
          {accountList.length > 5 && readMore ? (
            <div>
              5、授权账户包括{' '}
              {accountList.slice(0, 5).map((item, index) => (
                <span key={index}>
                  {item.enterprise_name}（主体ID：{item.account_id}）
                  {index === accountList.slice(0, 5).length - 1 ? '' : '、'}
                </span>
              ))}{' '}
              等所有归属于您的账户。
              <span style={{ color: '#296bef', cursor: 'pointer' }} onClick={() => setReadMore(false)}>
                查看更多
              </span>
            </div>
          ) : (
            <div>
              5、授权账户包括{' '}
              {accountList?.map((item, index) => (
                <span key={index}>
                  {item.enterprise_name}（主体ID：{item.account_id}）{index === accountList.length - 1 ? '' : '、'}
                </span>
              ))}{' '}
              等所有归属于您的账户。
            </div>
          )}
        </div>
      </div>
    );
  }
  return <div />;
};

export default OneKeyAuth;
